import Vue from "vue";

export const MULTI_TAB_ROUTES = ["PSTORESaleFactorAdd"];

export function isMultiTabRoute(name) {
  return MULTI_TAB_ROUTES.includes(name);
}

const FORM_ROUTE = /(Add|Edit)([A-Z]|$)/;

export function isFormRoute(name) {
  return FORM_ROUTE.test(name || "");
}
export const KEEP_ALIVE_FORM_ROUTES = [
  "PBANKAddReceiveCash",
  "PBANKEditReceiveCash",
  "PBANKAddPaymentCash",
  "PBANKEditPaymentCash",
  "PBANKAddPaymentRequest",
  "PBANKEditPaymentRequest",
  "PBANKAddReceiveCheque",
  "PBANKEditReceiveCheque",
  "PBANKAddReceiveChequeGroup",
  "PBANKAddPaymentCheque",
  "PBANKEditPaymentCheque",
  "PBANKAddPaymentChequeGroup",
  "PBANKAddReceiveCashGroup",
  "PBANKAddPaymentCashGroup",
  "PBANKAddInterBankTransfer",
  "PBANKEditInterBankTransfer",
];

export const KEEP_ALIVE_ROUTES = ["PBANKSummaryReport"];

export const KEEP_ALIVE_EXCLUDED_ROUTES = [
  "PACNTAccountOperationDetailReport",
  "PACNTIndividualOperationDetailReport",
  "PACNTFloatAccountOperationDetail",
  "PACNTFloatAccountOperationDetailLevelTwo",
  "PACNTFloatAccountOperationDetailLevelThree",
  "PACNTFloatAccountOperationDetailLevelFour",
  "PACNTFloatAccountOperationDetailLevelFive",
  "PACNTFloatAccountTextOperationDetail",
  "PBASEBranchTaxSetting",
  "PCRMPersonClub",
  "PCRMDiscount",
  "PCRMFeedbackAnswerSheet",
  "PCRMFeedbackHistoryDetails",
  "PCRMFeedbackHistoryAllDetails",
  "PMKTLead",
  "PMKTLeadSaleTeamAssignment",
  "PMKTLeadEvaluationCartable",
  "PMKTChanceList",
  "PSALESalePricePolicyGroup",
  "PSLRYPayrollEmployee",
  "PSLRYInsuranceEmployee",
  "PSLRYTaxEmployee",
  "PSTOREBenefitCardTransactions",
  "PTAXInvoice",
  "PWHRSWareShelf",
  "PWHRSCommodityGroupConfig",
];

function hasMethod(options, name) {
  if (!options) return false;
  if (options.methods && typeof options.methods[name] === "function") {
    return true;
  }
  return (options.mixins || []).some((mixin) => hasMethod(mixin, name));
}

export function isKeepAliveRoute(route) {
  const name = route && route.name;
  if (!name) return false;
  if (
    isMultiTabRoute(name) ||
    KEEP_ALIVE_FORM_ROUTES.includes(name) ||
    KEEP_ALIVE_ROUTES.includes(name)
  ) {
    return true;
  }
  if (isFormRoute(name) || KEEP_ALIVE_EXCLUDED_ROUTES.includes(name)) {
    return false;
  }
  const page = route.matched[route.matched.length - 1];
  return !!page && hasMethod(page.components.default, "reloadData");
}

export function clearRouteFilterState(routeName) {
  if (!routeName) return;
  try {
    sessionStorage.removeItem(routeName + "-SearchForm");
    Object.keys(localStorage)
      .filter(
        (key) =>
          key.startsWith(routeName + "-") && key.endsWith("-ColumnsState"),
      )
      .forEach((key) => {
        const state = JSON.parse(localStorage.getItem(key));
        if (!state) return;
        Object.values(state.columns || {}).forEach((column) => {
          column.filterValue = null;
        });
        state.searchText = "";
        localStorage.setItem(key, JSON.stringify(state));
      });
  } catch (e) {
    // ذخیره‌سازی در دسترس نیست؛ چیزی برای پاک کردن نیست
  }
}

export function cacheKeyOf(route) {
  const tab = tabKeyOf(route);
  const params = route && route.params;
  if (!tab || !params || !Object.keys(params).length) return tab;
  return tab + "@" + JSON.stringify(params);
}

export function tabOfCacheKey(key) {
  return key ? key.split("@")[0] : key;
}

let lastTabId = 0;

export function tabKeyOf(route) {
  if (!route) return null;
  const name = route.name || route.routeName;
  const tab = route.query && route.query.tab;
  return isMultiTabRoute(name) && tab ? `${name}#${tab}` : name;
}

export function tabNumberOf(route) {
  const tab = route && route.query && Number(route.query.tab);
  return tab > 0 ? tab : null;
}

export function withNewTabId(to) {
  if (!isMultiTabRoute(to.name)) return null;
  const current = tabNumberOf(to);
  if (current) {
    lastTabId = Math.max(lastTabId, current);
    return null;
  }
  lastTabId += 1;
  return {
    name: to.name,
    params: to.params,
    query: { ...to.query, tab: String(lastTabId) },
    replace: true,
  };
}

const drafts = Vue.observable({ dirty: {} });

export function setTabDirty(key, dirty) {
  if (!key) return;
  if (dirty) Vue.set(drafts.dirty, key, true);
  else Vue.delete(drafts.dirty, key);
}

export function isTabDirty(key) {
  return !!drafts.dirty[key];
}

export const TAB_CLOSED_EVENT = "multi-tab-closed";
